import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

import { ServicoMsg } from '../../servicos/srv.msg';
import { ServicoFornecedor } from '../../servicos/srv.produto';

@Component({
  selector: 'tsv2-frn-listar',
  templateUrl: './listar.component.html',
  providers: [ ServicoMsg, ServicoFornecedor ]
})
export class FornecedorListarComponent implements OnInit {
  @Input() items: any[];
  @Input() pagina: number;

  @Output() trocar = new EventEmitter();

  constructor(
    private spinner: NgxSpinnerService,
    private servicoMsg: ServicoMsg,
    private servicoFornecedor: ServicoFornecedor
  ) {
    this.items = [];
    this.pagina = 1;
  }

  ngOnInit() {
  }

  removerFornecedor(id){
    let titulo = 'Remover o fornecedor?';
    let texto = 'Fornecedor removido com sucesso!';
    this.servicoMsg.exibeAlerta(titulo, id, this.servicoFornecedor, texto).then(r1 => {
      if (r1.success){
        this.trocar.emit(this.pagina);
      }
    }, (err: any) => {
      this.servicoMsg.exibeErro(err).then(r1 => {});
    });
  }

}
